<app-confirm-dialog
  #confirmModal
  [title]="'Are you sure to reset questions?'"
  [message]="'The previous questions will not be visible in your future online meetings. This will load the default questions.'"
  (confirmed)="handleResetQuestions($event)"
></app-confirm-dialog>

<app-confirm-dialog
  #deleteQuestionModal
  [title]="'Delete this question?'"
  [message]="deleteQuestionMessage"
  (confirmed)="handleDeleteQuestion($event)"
></app-confirm-dialog>

<app-confirm-dialog
  #deleteTemplateModal
  [title]="'Delete this template?'"
  [message]="'All questions in this template will be permanently deleted. This cannot be undone.'"
  (confirmed)="handleDeleteTemplate($event)"
></app-confirm-dialog>

<app-qualify-demo #qualifyDemo></app-qualify-demo>

<div class="modal-overlay generate-choice-modal" [class.visible]="showGenerateChoiceModal" (click)="closeGenerateChoiceModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3 class="modal-title">Generated questions will replace current ones</h3>
      <button type="button" class="modal-close-btn" (click)="closeGenerateChoiceModal()">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </div>
    <div class="modal-body">
      <p class="modal-text">
        You already have questions in this template. Choose how you want to continue.
      </p>
    </div>
    <div class="modal-footer generate-choice-actions">
      <button type="button" class="action-btn secondary" (click)="confirmGenerateReplaceCurrent()">Replace Current Questions</button>
      <button type="button" class="action-btn primary" (click)="confirmGenerateInNewTemplate()">Create New Template</button>
    </div>
  </div>
</div>

<div class="modal-overlay generate-template-name-modal" [class.visible]="showGenerateTemplateNameModal" (click)="closeGenerateTemplateNameModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3 class="modal-title">Name Your New Template</h3>
      <button type="button" class="modal-close-btn" (click)="closeGenerateTemplateNameModal()">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </div>
    <div class="modal-body">
      <div class="modal-form-group">
        <label class="modal-label">Template Name</label>
        <input
          type="text"
          class="modal-input"
          [(ngModel)]="generateTemplateName"
          [ngModelOptions]="{standalone: true}"
          placeholder="e.g., Discovery Call - Enterprise"
          (keydown.enter)="createTemplateAndGenerate()"
          autofocus
        />
      </div>
    </div>
    <div class="modal-footer generate-template-name-actions">
      <button
        type="button"
        class="action-btn primary"
        (click)="createTemplateAndGenerate()"
        [disabled]="isGenerating || !generateTemplateName.trim()"
      >
        {{ isGenerating ? 'Creating...' : 'Create &amp; Generate' }}
      </button>
    </div>
  </div>
</div>

<app-main-wrapper title="Questions">
  <button
    type="button"
    class="page-help"
    page-actions
    (click)="openQualifyDemo()"
    aria-label="Explain Qualify"
    title="Explain Qualify"
  >
    ?
  </button>
  <div class="questions-page">

    <!-- ── Template Tabs ──────────────────────────────────────────────── -->
    <div class="template-tabs" *ngIf="templatesEnabled">
      <div
        *ngFor="let t of templates; let i = index"
        class="template-tab"
        [class.active]="t.id === currentTemplateId"
        [class.dragging]="dragSourceIndex === i"
        [class.drag-over]="dragOverIndex === i && dragSourceIndex !== i"
        [draggable]="templates.length > 1 && renamingTemplateId !== t.id"
        (click)="switchTemplate(t.id)"
        (dragstart)="onTabDragStart(i)"
        (dragover)="onTabDragOver(i, $event)"
        (drop)="onTabDrop(i, $event)"
        (dragend)="onTabDragEnd()"
      >
        <input
          *ngIf="renamingTemplateId === t.id"
          class="tab-rename-input"
          [(ngModel)]="renameValue"
          [ngModelOptions]="{standalone: true}"
          (blur)="saveRename()"
          (keydown)="onRenameKeydown($event)"
          (click)="$event.stopPropagation()"
          autofocus
        />
        <span
          *ngIf="renamingTemplateId !== t.id"
          (dblclick)="startRename(t, $event)"
        >{{ t.name }}</span>
        <button
          *ngIf="templates.length > 1 && renamingTemplateId !== t.id"
          type="button"
          class="tab-close"
          (click)="confirmDeleteTemplate(t.id, $event)"
          title="Delete template"
        >
          <fa-icon [icon]="faTimes"></fa-icon>
        </button>
      </div>
      <button
        type="button"
        class="add-template-btn"
        [class.empty]="templates.length === 0"
        (click)="openNewTemplateModal()"
        title="Add template"
      >
        <fa-icon [icon]="faPlus" class="add-template-icon"></fa-icon>
        <span class="add-template-label" *ngIf="templates.length === 0">Add Template</span>
        <span class="add-template-new" *ngIf="templates.length > 0">New</span>
      </button>
    </div>


    <div class="generate-panel">
      <div class="generate-container">
        <div class="generate-left">
          <textarea
            [(ngModel)]="aiPrompt"
            (ngModelChange)="onAiPromptChange()"
            [ngModelOptions]="{standalone: true}"
            class="generate-input"
            placeholder="Generate BANT questions for enterprise SaaS or paste your current questions set."
            [disabled]="isGenerating"
          ></textarea>
          <div class="template-chips">
            <button type="button" class="template-chip"
              [class.template-chip--active]="selectedPromptKey === 'BANT'"
              (click)="setAiPrompt('BANT')">BANT Questions</button>
            <button type="button" class="template-chip"
              [class.template-chip--active]="selectedPromptKey === 'MEDDPICC'"
              (click)="setAiPrompt('MEDDPICC')">MEDDPICC Questions</button>
            <button type="button" class="template-chip"
              [class.template-chip--active]="selectedPromptKey === 'SPIN'"
              (click)="setAiPrompt('SPIN')">SPIN Questions</button>
            <button type="button" class="template-chip"
              [class.template-chip--active]="selectedPromptKey === '15-min call'"
              (click)="setAiPrompt('15-min call')">15-min call</button>
          </div>
        </div>
        <button
          type="button"
          class="ai-generate-btn"
          (click)="generateQuestions()"
          [disabled]="isGenerating || !aiPrompt.trim()"
        >
          <span class="sparkle-1"></span>
          <span class="sparkle-2"></span>
          <span class="sparkle-3"></span>
          <span *ngIf="isGenerating" class="spinner-sm"></span>
          <fa-icon *ngIf="!isGenerating" [icon]="faWandMagicSparkles"></fa-icon>
          {{ isGenerating ? 'Generating...' : 'Generate' }}
        </button>
      </div>
    </div>

    <!-- View Mode -->
    <div *ngIf="!isEditMode" class="questions-container">
      <div
        *ngIf="savedQuestions.length === 0"
        class="empty-state"
        role="button"
        tabindex="0"
        aria-label="Add meeting questions"
        (click)="startCustomQuestions()"
        (keydown.enter)="startCustomQuestions($event)"
        (keydown.space)="startCustomQuestions($event)"
      >
        <fa-icon [icon]="faPlus" class="empty-icon"></fa-icon>
        <p class="empty-title">No questions configured yet</p>
        <p class="empty-subtitle">Click below to add your meeting questions.</p>
        <div class="empty-actions">
          <button type="button" class="empty-btn primary" (click)="startCustomQuestions($event)">
            Add questions
          </button>
          <button type="button" class="empty-btn secondary" (click)="loadDefaultQuestionSet($event)">
            Load default questions
          </button>
        </div>
      </div>

      <div class="question-list" *ngIf="savedQuestions.length > 0">
        <div
          *ngFor="let question of savedQuestions; let i = index"
          class="question-item"
          [class.published]="isPublished"
        >
          <div class="question-content">
            <div class="question-number">{{ i + 1 }}.</div>
            <div class="question-text">{{ question.question_text }}</div>
          </div>
        </div>
      </div>

      <div class="bottom-actions" *ngIf="savedQuestions.length > 0">
        <button
          type="button"
          class="action-btn primary edit-questions-btn"
          (click)="toggleEditMode()"
        >
          Edit Questions
        </button>

        <button
          type="button"
          class="action-btn secondary"
          (click)="resetQuestions()"
        >
          Reset Questions
        </button>
      </div>
    </div>

    <!-- Edit Mode -->
    <form *ngIf="isEditMode" [formGroup]="questionForm" (ngSubmit)="submit()" class="edit-form">
      <div 
        class="questions-container editing" 
        formArrayName="questions"
        cdkDropList 
        (cdkDropListDropped)="onQuestionDrop($event)"
      >
        <div 
          *ngFor="let question of questions.controls; let i = index" 
          [formGroupName]="i" 
          cdkDrag
          class="question-item editable"
          [ngClass]="shouldAnimateNewQuestions ? 'stagger-' + i : ''">
          <div class="question-content">
            <button 
              type="button" 
              class="drag-handle"
              title="Drag to reorder"
              cdkDragHandle
            >
              <fa-icon [icon]="faGripVertical"></fa-icon>
            </button>
            <div class="question-number">{{ i + 1 }}.</div>
            <input
              type="text"
              formControlName="question_text"
              class="question-input"
              placeholder="Enter your question"
            />
            <div class="question-actions">
              <button
                type="button"
                class="action-btn add-btn"
                (click)="addMore(i)"
                title="Add question after this one"
              >
                <fa-icon [icon]="faPlus"></fa-icon>
              </button>
              <button
                type="button"
                class="action-btn delete-btn"
                (click)="removeQuestion(i)"
                [disabled]="questions.length <= 1"
                [title]="questions.length <= 1 ? 'Cannot delete the last question' : 'Delete this question'"
              >
                <fa-icon [icon]="faTrash"></fa-icon>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="form-actions">
        <button 
          type="submit" 
          class="action-btn primary publish-questions-btn"
          [disabled]="isRequestPending || !questionForm.valid"
        >
          {{ isRequestPending ? 'Publishing...' : 'Publish Questions' }}
        </button>

        <button
          type="button"
          class="action-btn secondary"
          (click)="resetQuestions()"
        >
          Reset Questions
        </button>

        <button
          type="button"
          class="action-btn secondary"
          (click)="toggleEditMode()"
        >
          Cancel
        </button>
      </div>
    </form>
  </div>
</app-main-wrapper>

<!-- ── New Template Modal ───────────────────────────────────────────────── -->
<div class="modal-overlay" [class.visible]="showNewTemplateModal" (click)="closeNewTemplateModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3 class="modal-title">Create New Template</h3>
      <button type="button" class="modal-close-btn" (click)="closeNewTemplateModal()">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </div>
    <div class="modal-body">
      <div class="modal-form-group">
        <label class="modal-label">Template Name</label>
        <input
          type="text"
          class="modal-input"
          [(ngModel)]="newTemplateName"
          [ngModelOptions]="{standalone: true}"
          placeholder="e.g., Enterprise SaaS Questions"
          (keydown.enter)="createTemplate()"
          autofocus
        />
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="action-btn secondary" (click)="closeNewTemplateModal()">Cancel</button>
      <button
        type="button"
        class="action-btn primary"
        (click)="createTemplate()"
        [disabled]="!newTemplateName.trim()"
      >
        Create &amp; Switch
      </button>
    </div>
  </div>
</div>

<!-- ── Unsaved Changes Guard Modal ──────────────────────────────────────── -->
<div class="modal-overlay unsaved-changes-modal" [class.visible]="showUnsavedChangesModal" (click)="cancelPendingNavigation()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3 class="modal-title">You have unsaved questions</h3>
      <button type="button" class="modal-close-btn" (click)="cancelPendingNavigation()">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </div>
    <div class="modal-body">
      <p class="modal-text">You've generated questions that haven't been published yet. What would you like to do?</p>
    </div>
    <div class="modal-footer unsaved-changes-actions">
      <button type="button" class="action-btn secondary discard-btn" (click)="confirmDiscardAndNavigate()">Discard &amp; Leave</button>
      <button type="button" class="action-btn primary" (click)="saveAndNavigate()">Publish &amp; Leave</button>
    </div>
  </div>
</div>
